app.config(['$stateProvider',
    function ($stateProvider) {

        $stateProvider
            .state("index", {
                url: "/",
                templateUrl: _pb + "default/index.html",
                controller: "IndexController",
                data: { requireLogin: false }
            })
            .state("login", {
                url: "/login",
                templateUrl: _pb + "auth/login.html",
                controller: "LoginController",
                data: { requireLogin: false }
            })
            .state("verify-phone", {
                url: "/verify",
                templateUrl: _pb + "sms/verify-phone.html",
                controller: "VerifyPhoneController",
                data: { requireLogin: false }
            })
            .state("sms-auth", {
                url: "/sms-auth",
                templateUrl: _pb + "sms/sms-auth.html",
                controller: "SmsAuthController",
                data: { requireLogin: false }
            })
            .state("two-factor-auth", {
                url: "/two-factor-auth",
                templateUrl: _pb + "auth/two-factor-auth.html",
                controller: "TwoFactorAuthController",
                data: { requireLogin: false }
            })
            .state("register", {
                url: "/register",
                templateUrl: _pb + "auth/register.html",
                controller: "RegisterController",
                data: { requireLogin: false }
            })
            .state("reset", {
                url: "/reset",
                templateUrl: _pb + "auth/reset.html",
                controller: "ResetController",
                data: { requireLogin: false }
            })
            .state("restore", {
                url: "/restore/:token",
                templateUrl: _pb + "auth/restore.html",
                controller: "RestoreController",
                data: { requireLogin: false }
            })
            .state("change-mail", {
                url: "/email/change?resend&profile",
                templateUrl: _pb + "auth/change-mail.html",
                controller: "ChangeMailController",
                data: { requireLogin: true },
                params: {
                    resend: {
                        value: '',
                        squash: true
                    },
                    profile: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("confirm-mail", {
                url: "/email/verification/:token",
                templateUrl: _pb + "auth/verify-mail.html",
                controller: "VerifyMailController",
                data: { requireLogin: false }
            })
            .state("profile", {
                url: "/profile",
                templateUrl: _pb + "profile/index.html",
                controller: "ProfileController",
                data: { requireLogin: true }
            })
            .state("sudo", {
                abstract: true,
                templateUrl: _pb + "sudo/layout.html",
                url: "/sudo"
            })
            .state("sudo.index", {
                templateUrl: _pb + "sudo/index.html",
                url: "/",
                data: { requireLogin: true }
            })
            .state("sudo.permission", {
                url: "/permission?type",
                templateUrl: _pb + "sudo/access/permission.html",
                controller: "PermissionController",
                data: { requireLogin: true },
                params: {
                    type: {
                        value: 'USER',
                        squash: true
                    }
                }
            })
            .state("sudo.users", {
                url: "/users?page&query&right&signature",
                templateUrl: _pb + "sudo/users/index.html",
                controller: "UsersIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    right: {
                        value: '',
                        squash: true
                    },
                    signature: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("sudo.admins", {
                url: "/admins?page&query&faculty",
                templateUrl: _pb + "sudo/admins/index.html",
                controller: "AdminsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    }
                }
            })
            // sudo.role is now a native Angular component state — see static-src/app/ng/app.states.ts
            .state("sudo.configuration", {
                url: "/sysparam",
                templateUrl: _pb + "sudo/sysparam/system-parameters.html",
                controller: "SysParamController",
                data: { requireLogin: true }
            })
            // sudo.grade-templates migrated to a native Angular component state (Phase 6) — see
            // ng/app.routes.ts. The edit page below is still AngularJS.
            .state("sudo.grade-template-edit", {
                url: "/grade-templates/edit/:templateId",
                templateUrl: _pb + "sudo/grade-templates/edit-grade-template.html",
                controller: "EditGradeTemplateController",
                data: { requireLogin: true }
            })
            .state("sudo.utils", {
                url: "/utils",
                templateUrl: _pb + "sudo/utils/index.html",
                controller: "SudoUtilsController",
                data: { requireLogin: true }
            })
            .state("sudo.grades-export", {
                url: "/grades-export",
                templateUrl: _pb + "sudo/utils/grades-export-list.html",
                controller: "SudoGradesExportListController",
                data: { requireLogin: true }
            })
            .state("sudo.import-candidates", {
                url: "/import-candidates",
                templateUrl: _pb + "sudo/utils/import-candidates.html",
                controller: "SudoImportCandidatesController",
                data: { requireLogin: true }
            })
            .state("sudo.parameters", {
                url: "/parameters",
                templateUrl: _pb + "parameters/index.html",
                controller: "ParametersController",
                data: { requireLogin: true }
            })
            .state("sudo.seasons", {
                url: "/seasons",
                templateUrl: _pb + "sudo/seasons/seasons-index.html",
                controller: "SeasonController",
                data: { requireLogin: true }
            })
            .state("sudo.season-weeks", {
                url: "/seasons/:seasonId/weeks",
                templateUrl: _pb + "sudo/seasons/season-weeks.html",
                controller: "SeasonWeeksController",
                data: { requireLogin: true }
            })
            .state("sudo.grades-statistics", {
                url: "/grades-statistics?page&limit&student&personalNo&level&semesters&programs&subject&faculties&studentStates&selectionState&seasons",
                templateUrl: _pb + "sudo/grades-statistics/index.html",
                controller: "GradesStatisticsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '25',
                        squash: true
                    },
                    student: {
                        value: '',
                        squash: true
                    },
                    personalNo: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    semesters: {
                        array: true
                    },
                    programs: {
                        array: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    faculties: {
                        array: true
                    },
                    studentStates: {
                        array: true
                    },
                    selectionState: {
                        value: '',
                        squash: true
                    },
                    seasons: {
                        array: true
                    }
                }
            })
            // .state("sudo.notification", {
            //     abstract: true,
            //     template: '<div ui-view=""></div>',
            //     url: "/notification",
            //     data: {requireLogin: true}
            // })
            // .state("sudo.notification.received", {
            //     url: "/notifications?page?query",
            //     templateUrl: _pb + "notifications/index.html",
            //     controller: "ReceivedNotificationController",
            //     data: {requireLogin: true},
            //     params: {
            //         page: {
            //             value: '1',
            //             squash: true
            //         },
            //         query: {
            //             value: '',
            //             squash: true
            //         }
            //     }
            // })
            // .state("sudo.polls.received", {
            //     url: "/notifications?page?query",
            //     templateUrl: _pb + "notifications/polls.html",
            //     controller: "ReceivedPollsController",
            //     data: {requireLogin: true},
            //     params: {
            //         page: {
            //             value: '1',
            //             squash: true
            //         },
            //         query: {
            //             value: '',
            //             squash: true
            //         }
            //     }
            // })
            .state("sudo.received", {
                abstract: true,
                templateUrl: _pb + "notifications/tabs.html",
                url: "/received",
                data: { requireLogin: true }
            })
            .state("sudo.received.notifications", {
                url: "/notifications?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("sudo.received.polls", {
                url: "/polls?page&query",
                templateUrl: _pb + "notifications/polls.html",
                controller: "ReceivedPollsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("sudo.programs", {
                url: "/program?query&faculty&level&state",
                templateUrl: _pb + "sudo/programs/index.html",
                controller: "SudoProgramsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    selectionState: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin", {
                abstract: true,
                templateUrl: _pb + "admin/layout.html",
                controller: "AdminLayoutController",
                url: "/admin"
            })
            .state("admin.index", {
                url: "/",
                templateUrl: _pb + "admin/index.html",
                data: { requireLogin: true }
            })
            .state("admin.parameters", {
                url: "/parameters",
                templateUrl: _pb + "parameters/index.html",
                controller: "ParametersController",
                data: { requireLogin: true }
            })
            .state("admin.users", {
                url: "/users?page&query",
                templateUrl: _pb + "admin/users/index.html",
                controller: "UserIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.students", {
                url: "/students?page&limit&query&faculty&level&subject&state&sortType&program&semester&lastSeason",
                templateUrl: _pb + "admin/students/index.html",
                controller: "StudentsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    gender: {
                        value: '',
                        squash: true
                    },
                    lastSeason: {
                        value: '',
                        squash: true
                    },
                    sortType: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    semester: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.studentCard", {
                url: "/students/:studentId",
                templateUrl: _pb + "admin/students/student-card.html",
                controller: "StSubController",
                data: { requireLogin: true }
            })
            .state("admin.studentCardByProgram", {
                url: "/cardByProgram?studentId&lastSemesterCredits",
                templateUrl: _pb + "admin/students/card-by-program.html",
                controller: "CardByProgramController",
                params: {
                    student: null
                },
                data: { requireLogin: true }
            })
            .state("admin.studentPayments", {
                url: "/student/payments/:studentId",
                templateUrl: _pb + "admin/students/student-payments.html",
                controller: "StudentPaymentsController",
                params: {
                    student: null
                },
                data: { requireLogin: true }
            })

            .state("admin.student-registration", {
                url: "/student-registration?page&limit&query&faculty&level&sortType&program&semester",
                templateUrl: _pb + "admin/student-registration/student-registration-index.html",
                controller: "StudentRegistrationIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    sortType: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    semester: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("admin.student-registration-register", {
                url: "/student-registration/register/:studentId",
                templateUrl: _pb + "admin/student-registration/student-registration-register.html",
                controller: "StudentRegistrationRegisterController",
                data: { requireLogin: true }
            })

            .state("admin.lecturers", {
                url: "/lecturers?page&query&faculty&activeState",
                templateUrl: _pb + "admin/lecturers/index.html",
                controller: "LecturersIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.lecturerCard", {
                url: "/lecturers/:lecturerId?season&year",
                templateUrl: _pb + "admin/lecturers/lecturer-card.html",
                controller: "LecturerCardController",
                data: { requireLogin: true }
            })
            .state("admin.lecturerGroup", {
                url: "/lecturers/lecturer/:groupId?page&limit",
                templateUrl: _pb + "admin/lecturers/lecturer-group.html",
                controller: "LecturerGroupController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.subject", {
                url: "/subject?page&query&level&prerequisite",
                templateUrl: _pb + "admin/subject/index.html",
                controller: "SubjectIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    prerequisite: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.subject-details", {
                url: "/subjects/:subjectId?page&limit&query&faculty&level&state&program&subjectState&semester",
                templateUrl: _pb + "admin/subject/subject-details.html",
                controller: "SubjectDetailsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    subjectId: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    subjectState: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    semester: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("admin.subject-syllabus", {
                url: "/subject-syllabus/:subjectId?action",
                templateUrl: _pb + "admin/subject/subject-syllabus.html",
                controller: "SubjectSyllabusController",
                data: { requireLogin: true },
                params: {
                    subjectId: {
                        value: '',
                        squash: true
                    },
                    action: {
                        value: '',
                        squash: true
                    }
                }
            })
            /*.state("admin.hidden", {
             url: "/subject-migration?page&program&subject&emisProgram",
             templateUrl: _pb + "admin/hidden/subject-migration.html",
             controller: "SubjectMigrationController",
             data: {requireLogin: false},
             params: {
             page: {
             value: '1',
             squash: true
             },
             program: {
             value: '',
             squash: true
             },
             subject: {
             value: '',
             squash: true
             },
             emisProgram: {
             value: '',
             squash: true
             }
             }
             })*/
            // .state("admin.hidden2", {
            //     url: "/subject-migration-new?page&program&subject&emisProgram",
            //     templateUrl: _pb + "admin/hidden2/subject-migration.html",
            //     controller: "SubjectMigrationControllerNew",
            //     data: {requireLogin: false},
            //     params: {
            //         page: {
            //             value: '1',
            //             squash: true
            //         },
            //         program: {
            //             value: '',
            //             squash: true
            //         },
            //         subject: {
            //             value: '',
            //             squash: true
            //         },
            //         emisProgram: {
            //             value: '',
            //             squash: true
            //         }
            //     }
            // })
            .state("admin.program", {
                url: "/program?query&faculty&level&selectionState",
                templateUrl: _pb + "admin/programs/index.html",
                controller: "ProgramsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    selectionState: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.edit-program", {
                url: "/program/edit/:programId",
                templateUrl: _pb + "admin/programs/edit-program.html",
                controller: "EditProgramController",
                data: { requireLogin: true }
            })
            .state("admin.syllabus", {
                url: "/syllabus",
                templateUrl: _pb + "admin/syllabus/index.html",
                controller: "syllabusIndexController",
                data: { requireLogin: true }
            })
            .state("admin.received", {
                abstract: true,
                templateUrl: _pb + "notifications/tabs.html",
                url: "/received",
                data: { requireLogin: true }
            })
            .state("admin.received.notifications", {
                url: "/notifications?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.send", {
                abstract: true,
                template: '<div ui-view=""></div>',
                url: "/send",
                data: { requireLogin: true }
            })
            .state("admin.send.polls", {
                url: "/send?page&query&owned&fromDate&toDate",
                templateUrl: _pb + "admin/polls/index.html",
                controller: "PollsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    },
                    owned: {
                        value: 'false',
                        squash: true
                    }
                }
            })
            .state("admin.send.statistics", {
                url: "/statistics/:pollId?page&query",
                templateUrl: _pb + "admin/statistics/index.html",
                controller: "StatisticsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.createPolls", {
                url: "/poll/create?pollId&operationType",
                templateUrl: _pb + "admin/polls/create-poll.html",
                controller: "CreatePollController",
                data: { requireLogin: true },
                params: {
                    pollId: null,
                    operationType: null
                }
            })
            .state("admin.received.polls", {
                url: "/polls?page&limit",
                templateUrl: _pb + "notifications/polls.html",
                controller: "ReceivedPollsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.questionnaires", {
                abstract: true,
                template: '<div ui-view=""></div>',
                url: "/questionnaires",
                data: { requireLogin: true }
            })
            .state("admin.questionnaires.list", {
                url: "/list?page&query&type&fromDate&toDate",
                templateUrl: _pb + "admin/questionnaires/index.html",
                controller: "QuestionnairesIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.questionnaires.create", {
                url: "/create?operationType&questionnaireId",
                templateUrl: _pb + "admin/questionnaires/create-questionnaire.html",
                controller: "CreateQuestionnaireController",
                data: { requireLogin: true },
                params: {
                    questionnaireId: null,
                    operationType: null
                }
            })
            .state("admin.questionnaires.send", {
                url: "/send?questionnaireId",
                templateUrl: _pb + "admin/questionnaires/send-questionnaire.html",
                controller: "SendQuestionnaireController",
                data: { requireLogin: true },
                params: {
                    questionnaireId: {
                        value: '1',
                        squash: true
                    }
                }
            })
            .state("admin.questionnaires.history", {
                url: "/history?template&title&page&query&type&fromDate&toDate",
                templateUrl: _pb + "admin/questionnaires/history.html",
                controller: "QuestionnairesHistoryController",
                data: { requireLogin: true },
                params: {
                    template: {
                        value: '',
                        squash: true
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    title: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.questionnaires.versions", {
                url: "/versions?template&title&page&query&type&fromDate&toDate",
                templateUrl: _pb + "admin/questionnaires/versions.html",
                controller: "QuestionnaireVersionsController",
                data: { requireLogin: true },
                params: {
                    template: {
                        value: '',
                        squash: true
                    },
                    title: {
                        value: '',
                        squash: true
                    },
                }
            })
            .state("admin.notification", {
                abstract: true,
                template: '<div ui-view=""></div>',
                url: "/notification",
                data: { requireLogin: true }
            })
            .state("admin.notification.received", {
                url: "/received?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.notification.send", {
                url: "/send?page&query",
                templateUrl: _pb + "admin/notifications/index.html",
                controller: "NotificationsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.createNotifications", {
                url: "/notifications/create?notificationId&operationType",
                templateUrl: _pb + "admin/notifications/create-notification.html",
                controller: "CreateNotificationController",
                data: { requireLogin: true },
                params: {
                    notificationId: null,
                    operationType: null
                }
            })
            .state("admin.reminders", {
                url: "/reminders?page&query",
                templateUrl: _pb + "admin/reminders/index.html",
                controller: "RemindersIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.agreement", {
                abstract: true,
                template: '<div ui-view=""></div>',
                url: "/agreement",
                data: { requireLogin: true }
            })
            .state("admin.createAgreement", {
                url: "/agreements/create?agreementId&operationType",
                templateUrl: _pb + "admin/agreements/create-agreement.html",
                controller: "CreateAgreementController",
                data: { requireLogin: true },
                params: {
                    agreementId: null,
                    operationType: null
                }
            })
            .state("admin.agreement.send", {
                url: "/send?page&query",
                templateUrl: _pb + "admin/agreements/index.html",
                controller: "AgreementsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.selection", {
                url: "/selection?page&query&program&year&season&gradeTemplate",
                templateUrl: _pb + "admin/selection/index.html",
                controller: "SelectionIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    gradeTemplate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.StudentsSelectionStates", {
                url: "/selection/student/states?page&limit&query&faculty&level&selectionState&program&semester",
                templateUrl: _pb + "admin/selection/students-selection-states.html",
                controller: "StudentsSelectionStatesController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    selectionState: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    semester: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.activation-grades", {
                templateUrl: _pb + "lecturer/grades.html",
                url: "/activation-grades?activationId",
                controller: "EditActivationGradesController",
                data: { requireLogin: true }
            })
            .state("admin.exams", {
                url: "/exams?page&query",
                templateUrl: _pb + "admin/exams/index.html",
                controller: "ExamsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.rooms", {
                url: "/rooms?page&building&floor&room&{seatCountFrom:int}&{seatCountTo:int}&withComputers&withSmartBoard",
                templateUrl: _pb + "admin/manage/rooms.html",
                controller: "ManageRoomsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    building: {
                        value: '',
                        squash: true
                    },
                    floor: {
                        value: '',
                        squash: true
                    },
                    room: {
                        value: '',
                        squash: true
                    },
                    seatCountFrom: {
                        value: null,
                        squash: true
                    },
                    seatCountTo: {
                        value: null,
                        squash: true
                    },
                    withComputers: {
                        value: 'false',
                        squash: true
                    },
                    withSmartBoard: {
                        value: 'false',
                        squash: true
                    }
                }
            })
            .state("admin.groups", {
                url: "/groups?page&query&lecturer&subject&sessionType&isDefined",
                templateUrl: _pb + "admin/manage/groups.html",
                controller: "ManageGroupsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    lecturer: {
                        value: '',
                        squash: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    sessionType: {
                        value: '',
                        squash: true
                    },
                    isDefined: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.profilePhotos", {
                url: "/profilePhotos?page&query",
                templateUrl: _pb + "admin/profilePhotos/index.html",
                controller: "profilePhotosController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.exam-grades", {
                templateUrl: _pb + "lecturer/grades.html",
                url: "/exam-grades?subject",
                controller: "ExamGradesController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-index", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-index.html",
                url: "/exam/manager/index?page&student&subject&day&session&seat&status&program&level",
                controller: "ExamsManagerIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    student: {
                        value: '',
                        squash: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    day: {
                        value: '',
                        squash: true
                    },
                    session: {
                        value: '',
                        squash: true
                    },
                    seat: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.exams-manager-settings", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-settings.html",
                url: "/exam/manager/settings",
                controller: "ExamsManagerSettingsController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-computer", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-computer.html",
                url: "/exam/manager/computer",
                controller: "ExamsManagerComputersController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-exclusions", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-exclusions.html",
                url: "/exam/manager/exclusions",
                controller: "ExamsManagerExclusionsController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-specials", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-specials.html",
                url: "/exam/manager/specials",
                controller: "ExamsManagerSpecialsController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-halls", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-halls.html",
                url: "/exam/manager/halls",
                controller: "ExamsManagerHallsController",
                data: { requireLogin: true }
            })
            .state("admin.exams-manager-days", {
                templateUrl: _pb + "admin/exams/manager/exams-manager-days.html",
                url: "/exam/manager/days",
                controller: "ExamsManagerDaysController",
                data: { requireLogin: true }
            })
            .state("admin.timetable-index", {
                templateUrl: _pb + "admin/timetable/timetable-index.html",
                url: "/timetable/index",
                controller: "TimetableIndexController",
                data: { requireLogin: true }
            })
            .state("admin.timetable-rooms", {
                templateUrl: _pb + "admin/timetable/timetable-rooms.html",
                url: "/timetable/rooms?page&building&floor&room&{seatCountFrom:int}&{seatCountTo:int}&withComputers&withSmartBoard",
                controller: "TimetableRoomsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    building: {
                        value: '',
                        squash: true
                    },
                    floor: {
                        value: '',
                        squash: true
                    },
                    room: {
                        value: '',
                        squash: true
                    },
                    seatCountFrom: {
                        value: null,
                        squash: true
                    },
                    seatCountTo: {
                        value: null,
                        squash: true
                    },
                    withComputers: {
                        value: 'false',
                        squash: true
                    },
                    withSmartBoard: {
                        value: 'false',
                        squash: true
                    }
                }
            })

            .state("admin.timetable-rooms-by-time", {
                templateUrl: _pb + "admin/timetable/rooms-by-time.html",
                url: "/timetable/rooms-by-time?dayOfWeek&startTime",
                controller: "RoomsByTimeController",
                data: { requireLogin: true },
                params: {
                    dayOfWeek: {
                        value: '',
                        squash: true
                    },
                    startTime: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.languages", {
                templateUrl: _pb + "admin/languages/index.html",
                url: "/languages",
                controller: "LanguagesIndexController",
                data: { requireLogin: true }
            })
            .state("admin.selection-details", {
                templateUrl: _pb + "admin/selection/selection-details.html",
                url: "/selection/details/:activationId?page&query&group&limit",
                controller: "SelectionDetailsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    group: {
                        value: '',
                        squash: true
                    },
                    limit: {
                        value: '25',
                        squash: true
                    }
                }
            })
            .state("admin.selection-sessions", {
                templateUrl: _pb + "admin/selection/selection-sessions.html",
                url: "/selection/sessions/:activationId",
                controller: "SelectionSessionsController",
                data: { requireLogin: true }
            })
            .state("admin.calendar-events", {
                templateUrl: _pb + "admin/calendarEvents/index.html",
                url: "/calendar-events/?page&query",
                controller: "CalendarEventsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.calendar-events-add", {
                url: "/calendar-events/Add?notificationId",
                templateUrl: _pb + "admin/calendarEvents/calendar-event-add.html",
                controller: "CalendarEventAddController",
                data: { requireLogin: true }
            })
            .state("admin.calendar-events-edit", {
                url: "/calendar-events/Edit?notificationId",
                templateUrl: _pb + "admin/calendarEvents/calendar-event-edit.html",
                controller: "CalendarEventEditController",
                data: { requireLogin: true },
                params: {
                    calendarEventId: null
                }
            })
            .state("admin.evaluations-control", {
                templateUrl: _pb + "admin/evaluations/index.html",
                url: "/evaluations-control/?lecturer&range&page&limit",
                controller: "EvaluationsControlIndexController",
                data: { requireLogin: true },
                params: {
                    lecturer: {
                        value: '',
                        squash: true
                    },
                    range: {
                        value: '',
                        squash: true
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.group-posts", {
                templateUrl: _pb + "admin/group-posts/index.html",
                url: "/group-posts/?lecturer&page&limit",
                controller: "GroupPostsIndexController",
                data: { requireLogin: true },
                params: {
                    lecturer: {
                        value: '',
                        squash: true
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("admin.syllabus-control", {
                templateUrl: _pb + "admin/syllabus/syllabus-control.html",
                url: "/syllabus-control",
                controller: "SyllabusControlIndexController",
                data: { requireLogin: true }
            })
            // admin.grade-templates migrated to a native Angular component state (Phase 6) — see
            // ng/app.routes.ts. The edit page below is still AngularJS.
            .state("admin.grade-template-edit", {
                url: "/grade-templates/edit/:templateId",
                templateUrl: _pb + "sudo/grade-templates/edit-grade-template.html",
                controller: "EditGradeTemplateController",
                data: { requireLogin: true }
            })
            .state("admin.grades-statistics", {
                url: "/grades-statistics?page&limit&student&personalNo&level&semesters&programs&subject&faculties&studentStates&selectionState&seasons",
                templateUrl: _pb + "sudo/grades-statistics/index.html",
                controller: "GradesStatisticsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '25',
                        squash: true
                    },
                    student: {
                        value: '',
                        squash: true
                    },
                    personalNo: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    semesters: {
                        array: true
                    },
                    programs: {
                        array: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    faculties: {
                        array: true
                    },
                    studentStates: {
                        array: true
                    },
                    selectionState: {
                        value: '',
                        squash: true
                    },
                    seasons: {
                        array: true
                    }
                }
            })
            .state("student", {
                abstract: true,
                templateUrl: _pb + "student/layout.html",
                url: "/student",
                data: { requireLogin: true }
            })
            .state("student-new", {
                abstract: true,
                templateUrl: _pb + "student-new/layout.html",
                controller: "FreshLayoutController",
                data: { requireLogin: true }
            })
            .state("student-new.index", {
                templateUrl: _pb + "student-new/index.html",
                url: "/student-new?modal",
                controller: "StudentNewIndexController",
                data: { requireLogin: true }
            })
            .state("student-new.card", {
                templateUrl: _pb + "student-new/card.html",
                url: "/student-new/card?profile&modal",
                controller: "StudentNewCardController",
                data: { requireLogin: true }
            })
            .state("student-new.my-program", {
                templateUrl: _pb + "student-new/my-program.html",
                url: "/student-new/my-program?studentId",
                controller: "StudentNewMyProgramController",
                data: { requireLogin: true }
            })
            .state("student-new.selection", {
                templateUrl: _pb + "student-new/selections-lite.html",
                url: "/student-new/selection?modal",
                controller: "StudentNewSelectionLiteController",
                data: { requireLogin: true }
            })
            .state("student-new.selection-instruction", {
                templateUrl: _pb + "student-new/selections-instruction.html",
                url: "/student-new/selection/instruction?modal",
                controller: "StudentNewSelectionInstructionController",
                data: { requireLogin: false }
            })
            .state("student-new.payments", {
                templateUrl: _pb + "student-new/payments.html",
                url: "/student-new/payments?modal",
                controller: "StudentNewPaymentsController",
                data: { requireLogin: true }
            })
            .state("student-new.payment-schedule", {
                templateUrl: _pb + "student-new/student-payment-schedule.html",
                url: "/student-new/payment-schedule?modal",
                controller: "StudentPaymentScheduleController",
                data: { requireLogin: true }
            })
            .state("student-new.timetable", {
                templateUrl: _pb + "student-new/timetable.html",
                url: "/student-new/timetable?modal",
                controller: "StudentNewTimetableController",
                data: { requireLogin: true }
            })
            .state("student-new.exams", {
                templateUrl: _pb + "student-new/exams/exams-index.html",
                url: "/student-new/exams?modal",
                controller: "FreshStudentExamsIndexController",
                data: { requireLogin: true }
            })
            .state("student-new.profile", {
                templateUrl: _pb + "student-new/profile.html",
                url: "/student-new/profile?modal",
                controller: "StudentNewProfileController",
                data: { requireLogin: true }
            })
            .state("student-new.questionnaires", {
                templateUrl: _pb + "student-new/questionnaires.html",
                url: "/student-new/questionnaires?modal",
                controller: "StudentNewQuestionnairesController",
                data: { requireLogin: true }
            })
            .state("student-new.notifications", {
                templateUrl: _pb + "student-new/notifications.html",
                url: "/student-new/notifications?page&query&limit&state&fromDate&toDate&date&modal",
                controller: "StudentNewNotificationsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    limit: {
                        value: '25',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    },
                    date: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("student-new.docs", {
                templateUrl: _pb + "student-new/docs/student-docs-index.html",
                url: "/student-new/docs?page&type",
                controller: "StudentDocsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                }
            })

            .state("student.index", {
                templateUrl: _pb + "student/index.html",
                url: "/home",
                controller: "StIndexController",
                data: { requireLogin: true }
            })
            .state("student.table", {
                templateUrl: _pb + "student/table/index.html",
                url: "/table",
                controller: "StudentTableController",
                data: { requireLogin: true }
            })
            .state("student.passed", {
                templateUrl: _pb + "student/card/index.html",
                url: "/passed?profile",
                controller: "StudentCardController",
                data: { requireLogin: true },
                params: {
                    profile: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("student.exams", {
                templateUrl: _pb + "student/exams/exams-list.html",
                url: "/exams",
                controller: "StudentExamsListController",
                data: { requireLogin: true }
            })
            .state("student.select", {
                templateUrl: _pb + "student/selection/select.html",
                url: "/selection",
                controller: "StudentSelectionController",
                data: { requireLogin: true }
            })
            .state("student.parameters", {
                url: "/parameters",
                templateUrl: _pb + "parameters/index.html",
                controller: "ParametersController",
                data: { requireLogin: true }
            })
            .state("student.received", {
                abstract: true,
                templateUrl: _pb + "notifications/tabs.html",
                url: "/received",
                data: { requireLogin: true }
            })
            .state("student.received.notifications", {
                url: "/notifications?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("student.received.polls", {
                url: "/polls?page&query",
                templateUrl: _pb + "notifications/polls.html",
                controller: "ReceivedPollsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("lecturer", {
                abstract: true,
                templateUrl: _pb + "lecturer/layout.html",
                url: "/lecturer",
                data: { requireLogin: true }
            })
            .state("lecturer.index", {
                templateUrl: _pb + "lecturer/index.html",
                url: "/",
                controller: "LecturerIndexController",
                data: { requireLogin: true }
            })
            .state("lecturer.grades", {
                templateUrl: _pb + "lecturer/grades.html",
                url: "/grades?subject",
                controller: "LecturerGradesController",
                data: { requireLogin: true }
            })
            .state("lecturer.table", {
                templateUrl: _pb + "lecturer/table.html",
                url: "/table?lecturer",
                controller: "LecturerTableController",
                data: { requireLogin: true }
            })
            .state("lecturer.parameters", {
                url: "/parameters",
                templateUrl: _pb + "parameters/index.html",
                controller: "ParametersController",
                data: { requireLogin: true }
            })
            .state("lecturer.received", {
                abstract: true,
                templateUrl: _pb + "notifications/tabs.html",
                url: "/received",
                data: { requireLogin: true }
            })
            .state("lecturer.received.notifications", {
                url: "/notifications?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("lecturer.received.polls", {
                url: "/polls?page&limit",
                templateUrl: _pb + "notifications/polls.html",
                controller: "ReceivedPollsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("lecturer.subject-syllabus", {
                url: "/subject-syllabus/:subjectId?action",
                templateUrl: _pb + "admin/subject/subject-syllabus.html",
                controller: "SubjectSyllabusController",
                data: { requireLogin: true },
                params: {
                    subjectId: {
                        value: '',
                        squash: true
                    },
                    action: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("lecturer.students", {
                url: "/students?page&limit&query&faculty&level&subject&state&sortType&program&semester",
                templateUrl: _pb + "admin/students/index.html",
                controller: "StudentsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    faculty: {
                        value: '',
                        squash: true
                    },
                    level: {
                        value: '',
                        squash: true
                    },
                    subject: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    gender: {
                        value: '',
                        squash: true
                    },
                    sortType: {
                        value: '',
                        squash: true
                    },
                    program: {
                        value: '',
                        squash: true
                    },
                    semester: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("lecturer.studentCard", {
                url: "/students/:studentId",
                templateUrl: _pb + "admin/students/student-card.html",
                controller: "StSubController",
                data: { requireLogin: true }
            })
            .state("lecturer.selection-details", {
                templateUrl: _pb + "admin/selection/selection-details.html",
                url: "/selection/details/:activationId?page&query&group&limit",
                controller: "SelectionDetailsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    group: {
                        value: '',
                        squash: true
                    },
                    limit: {
                        value: '25',
                        squash: true
                    }
                }
            })

            .state("employee", {
                abstract: true,
                url: "/employee",
                templateUrl: _pb + "employee/layout.html",
                controller: "EmployeeLayoutController",
                data: { requireLogin: true }
            })

            .state("employee.index", {
                url: "/",
                templateUrl: _pb + "employee/index.html",
                data: { requireLogin: true }
            })

            .state("employee.staff", {
                url: "/staff?page&query&organizationId&positionName",
                templateUrl: _pb + "employee/staff/employee-staff.html",
                controller: "EmployeeStaffController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    organizationId: {
                        value: '',
                        squash: true
                    },
                    positionName: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.positionHistory", {
                url: "/positionHistory?page&employee&organization&position&positionType",
                templateUrl: _pb + "employee/positionHistory/position-history.html",
                controller: "PositionHistoryController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    employee: {
                        value: '',
                        squash: true
                    },
                    organization: {
                        value: '',
                        squash: true
                    },
                    position: {
                        value: '',
                        squash: true
                    },
                    positionType: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.document-types", {
                url: "/document-types?type",
                templateUrl: _pb + "employee/parameters/document-types.html",
                controller: "DocumentTypesController",
                data: { requireLogin: true },
                params: {
                    type: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents", {
                abstract: true,
                template: '<div ui-view=""></div>',
                url: "/documents",
                data: { requireLogin: true }
            })

            .state("employee.documents.new", {
                url: "/new?documentId&basis&action&department&returnUrl",
                templateUrl: _pb + "employee/documents/employee-new-document.html",
                controller: "EmployeeNewDocumentController",
                data: { requireLogin: true },
                params: {
                    documentId: {
                        value: '',
                        squash: true
                    },
                    basis: {
                        value: '',
                        squash: true
                    },
                    action: {
                        value: '',
                        squash: true
                    },
                    department: {
                        value: '',
                        squash: true
                    },
                    returnUrl: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.view", {
                url: "/view?documentId&actionType&status&infoId&returnUrl",
                templateUrl: _pb + "employee/documents/view.html",
                controller: "EmployeeViewDocumentController",
                data: { requireLogin: true },
                params: {
                    documentId: {
                        value: '',
                        squash: true
                    },
                    actionType: {
                        value: '',
                        squash: true
                    },
                    status: {
                        value: '',
                        squash: true
                    },
                    infoId: {
                        value: '',
                        squash: true
                    },
                    returnUrl: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.incoming", {
                url: "/incoming?page&query&fromDate&toDate&type&parentType&state&authorEmp&authorSt&uniqueNumber&authorOrg&actionRequired",
                templateUrl: _pb + "employee/documents/employee-documents-incoming.html",
                controller: "EmployeeIncomingDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                    parentType: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    authorEmp: {
                        value: '',
                        squash: true
                    },
                    authorSt: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    },
                    authorOrg: {
                        value: '',
                        squash: true
                    },
                    actionRequired: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.sent", {
                url: "/sent?page&query&fromDate&toDate&type&state&addressee&addresseeOrganizationalUnit&uniqueNumber",
                templateUrl: _pb + "employee/documents/employee-documents-sent.html",
                controller: "EmployeeSentDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    addressee: {
                        value: '',
                        squash: true
                    },
                    addresseeOrganizationalUnit: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.review", {
                url: "/review?page&query",
                templateUrl: _pb + "employee/documents/employee-documents-review.html",
                controller: "EmployeeReviewDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.external", {
                url: "/external?page&query&addressee&comment&uniqueNumber&author&type&topic",
                templateUrl: _pb + "employee/documents/employee-documents-external.html",
                controller: "EmployeeExternalDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    comment: {
                        value: '',
                        squash: true
                    },
                    topic: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    },
                    addressee: {
                        value: '',
                        squash: true
                    },
                    author: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.outgoing", {
                url: "/outgoing?page&query&addressee&comment&uniqueNumber&author&type",
                templateUrl: _pb + "employee/documents/employee-documents-outgoing.html",
                controller: "EmployeeOutgoingDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    comment: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    },
                    addressee: {
                        value: '',
                        squash: true
                    },
                    author: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.new-outgoing", {
                url: "/new-outgoing",
                templateUrl: _pb + "employee/documents/employee-documents-new-outgoing.html",
                controller: "EmployeeNewOutgoingDocumentController",
                data: { requireLogin: true }
            })

            .state("employee.documents.new-response", {
                url: "/new-response?basisDocNumber",
                templateUrl: _pb + "employee/documents/employee-documents-new-response.html",
                controller: "EmployeeNewResponseDocumentController",
                data: { requireLogin: true },
                params: {
                    basisDocNumber: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.new-internal", {
                url: "/new-internal",
                templateUrl: _pb + "employee/documents/employee-documents-new-internal.html",
                controller: "EmployeeNewInternalDocumentController",
                data: { requireLogin: true }
            })

            .state("employee.documents.new-external", {
                url: "/new-external",
                templateUrl: _pb + "employee/documents/employee-documents-new-external.html",
                controller: "EmployeeNewExternalDocumentController",
                data: { requireLogin: true }
            })

            .state("employee.documents.reviewed", {
                url: "/reviewed?limit&page&query&fromDate&toDate&type&chancelleryStatus&documentState&addressee&author&chancelleryWorker&uniqueNumber",
                templateUrl: _pb + "employee/documents/employee-documents-reviewed.html",
                controller: "EmployeeReviewedDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                    chancelleryStatus: {
                        value: '',
                        squash: true
                    },
                    documentState: {
                        value: '',
                        squash: true
                    },
                    addressee: {
                        value: '',
                        squash: true
                    },
                    author: {
                        value: '',
                        squash: true
                    },
                    chancelleryWorker: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.shared", {
                url: "/shared?page&query",
                templateUrl: _pb + "employee/documents/employee-documents-shared.html",
                controller: "EmployeeSharedDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.student", {
                url: "/student?page&query&type&parentType&state&subState&uniqueNumber&author&fromDate&toDate",
                templateUrl: _pb + "employee/documents/employee-student-documents.html",
                controller: "EmployeeStudentDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    type: {
                        value: '',
                        squash: true
                    },
                    parentType: {
                        value: '',
                        squash: true
                    },
                    state: {
                        value: '',
                        squash: true
                    },
                    subState: {
                        value: '',
                        squash: true
                    },
                    uniqueNumber: {
                        value: '',
                        squash: true
                    },
                    author: {
                        value: '',
                        squash: true
                    },
                    fromDate: {
                        value: '',
                        squash: true
                    },
                    toDate: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.documents.new-student", {
                url: "/new-student",
                templateUrl: _pb + "employee/documents/employee-documents-new-student.html",
                controller: "EmployeeNewStudentDocumentController",
                data: { requireLogin: true }
            })

            .state("employee.documents.draft", {
                url: "/draft?page&query&onlyOrganizationDrafts",
                templateUrl: _pb + "employee/documents/employee-documents-draft.html",
                controller: "EmployeeDraftDocumentsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    },
                    onlyOrganizationDrafts: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.organizational-units", {
                url: "/organizational-units",
                templateUrl: _pb + "employee/organizational-units/organizational-units-index.html",
                controller: "OrganizationalUnitsIndexController",
                data: { requireLogin: true }
            })
            .state("employee.organizational-units.positions", {
                url: "/organizational-positions",
                templateUrl: _pb + "employee/organizational-units/organizational-positions.html",
                controller: "OrganizationalPositionsController",
                data: { requireLogin: true },
                params: {
                    unit: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("employee.organizational-units.positions.employees", {
                url: "/organizational-employees?unit&page&query",
                templateUrl: _pb + "employee/organizational-units/organizational-employees.html",
                controller: "OrganizationalEmployeesController",
                data: { requireLogin: true },
                params: {
                    unit: {
                        value: '',
                        squash: true
                    },
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            //
            // .state("employee.organizational-positions", {
            //     url: "/organizational-positions?unit",
            //     templateUrl: _pb + "employee/organizational-units/organizational-positions.html",
            //     controller: "OrganizationalPositionsController",
            //     data: {requireLogin: true},
            //     params: {
            //         unit: {
            //             value: '',
            //             squash: true
            //         }
            //     }
            // })

            // .state("employee.organizational-employees", {
            //     url: "/organizational-employees?unit",
            //     templateUrl: _pb + "employee/organizational-units/organizational-employees.html",
            //     controller: "OrganizationalEmployeesController",
            //     data: {requireLogin: true},
            //     params: {
            //         unit: {
            //             value: '',
            //             squash: true
            //         }
            //     }
            // })

            .state("employee.positions", {
                url: "/positions?page&limit&organization&name",
                templateUrl: _pb + "employee/positions/index.html",
                controller: "PositionsIndexController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    limit: {
                        value: '',
                        squash: true
                    },
                    organization: {
                        value: '',
                        squash: true
                    },
                    name: {
                        value: '',
                        squash: true
                    }
                }
            })

            .state("employee.permissions", {
                url: "/permissions?type",
                templateUrl: _pb + "sudo/access/permission.html",
                controller: "PermissionController",
                data: { requireLogin: true },
                params: {
                    type: {
                        value: 'DOCFLOW',
                        squash: true
                    }
                }
            })

            // employee.roles is now a native Angular component state — see static-src/app/ng/app.states.ts
            .state("employee.parameters", {
                url: "/parameters",
                templateUrl: _pb + "parameters/index.html",
                controller: "ParametersController",
                data: { requireLogin: true }
            })
            .state("employee.parameters.alerts", {
                url: "/alerts",
                templateUrl: _pb + "parameters/login-alerts.html",
                controller: "LoginAlertsController",
                data: { requireLogin: true }
            })
            .state("employee.received", {
                abstract: true,
                templateUrl: _pb + "notifications/tabs.html",
                url: "/received",
                data: { requireLogin: true }
            })
            .state("employee.received.notifications", {
                url: "/notifications?page&query",
                templateUrl: _pb + "notifications/index.html",
                controller: "ReceivedNotificationController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("employee.received.polls", {
                url: "/polls?page&query",
                templateUrl: _pb + "notifications/polls.html",
                controller: "ReceivedPollsController",
                data: { requireLogin: true },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    query: {
                        value: '',
                        squash: true
                    }
                }
            })
            .state("employee.vacations", {
                url: "/vacations",
                templateUrl: _pb + "employee/vacations/index.html",
                controller: "VacationsController",
                data: { requireLogin: true }
            })
    }
]);
